import { isSome } from '@mbfab/shared'
import { clsx } from 'clsx'
import type { ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// noUncheckedIndexedAccess下では配列の先頭要素アクセスも `T | undefined` になる。
// モックデータのように「実際には必ず要素が存在する」配列から初期値を取り出す箇所で使う
// （呼び出し元の関数境界をまたいだ独自型ガードは narrowing が効かないことがあるため、
// このヘルパー内で narrowing を完結させ、戻り値の型自体を T にする）
export function firstOrThrow<T>(array: readonly T[], message: string): T {
  const value = array[0]
  if (!isSome(value)) {
    throw new Error(message)
  }
  return value
}
